function learningProfileRowState(row = {}) {
  const evidenceCount = Number(row.evidenceCount || 0);
  const reproduced = Number(row.reproduced || 0);
  const blocking = evidenceCount > reproduced;
  const changed = row.changed === true;
  return {
    blocking,
    changed,
    needsReview: blocking || changed,
    selectable: changed && !blocking,
  };
}

module.exports = { learningProfileRowState };
